import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import YashImg from '../assets/images/Yash.png'

const Yash = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Yash - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={YashImg}
                    Title="Yash"
                    Designation="Property Consultant"
                    PhoneNumberLink="+919109302364"
                    PhoneNumber="+91 91093 02364"
                    WhatsappLink="919109302364"
                    Whatsapp="+91 91093 02364"
                    Email="yash@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={YashImg}
                    Title="Yash"
                    Designation="Property Consultant"
                    PhoneNumberLink="+919109302364"
                    PhoneNumber="+91 91093 02364"
                    WhatsappLink="919109302364"
                    Whatsapp="+91 91093 02364"
                    Email="yash@800homes.ae"
                />
            </section>
        </>
    )
}

export default Yash
